<template>
  <vs-popup class="edit-venue-popup"
    :title="'Pre orders for ' + activeVenue.name + ' on ' + formatPopupDate()"
    :active.sync="showPopup">

    <vs-row  v-if="enhancedBookings && enhancedBookings.length === 0">
      <vs-col vs-lg="3">
        <div>
          No tables
        </div>
      </vs-col>
    </vs-row>

    <div class="p-4">
      <div v-for="enhBooking in enhancedBookings"
            :key="enhBooking.booking.id"
            class="
              p-4text-sm mb-6
            "
          >
        <p><b>{{getTableNames(enhBooking)}}</b></p>
        <div v-for="(orderLine, index) in enhBooking.booking.orderLines" :key="index" class="mb-2">
          <div>
            <p>{{orderLine.quantity}} x {{orderLine.name}}</p>
          </div>
          <p class="text-grey"><small>{{orderLine.description}}</small></p>
        </div>
      </div>
    </div>

  </vs-popup>
</template>

<script>
import { mapGetters } from "vuex";
import moment from 'moment';

export default {
  components: { },
  data() {
    return {
      showPopup: false,
      date: null,
      enhancedBookings:null,
    };
  },
  computed: {
    ...mapGetters({
      activeVenue: "venues/activeVenue",
      activeVenueDetails: "marcom/activeVenue",
    })
  },
  methods: {
    show(date, enhancedBookings) {
      this.date = moment(date);
      this.date = moment.utc([this.date.year(), this.date.month(), this.date.date()]);
      this.showPopup = true;
      this.enhancedBookings = enhancedBookings;
    },
    formatPopupDate() {
      let noteMoment =  moment.utc(this.date);
      if(!noteMoment.isValid)
        return;
      return noteMoment.format('DD-MM-YYYY');
    },
    getTableNames(booking) {
      return booking.reservedTable.name;
    },
  },
};
</script>

<style lang="scss" scoped>
@keyframes fadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

.edit-venue-popup.con-vs-popup .vs-popup {
  max-width: 1080px !important;
  position: relative;

  .vs-popup-text {
    padding: 2rem !important;
  }

  .popup-title {
    padding: 2rem;
  }
}

.vs-popup {
  position: relative;

  overflow-y: auto;
  overflow-x: clip;
  max-height: 100%;
}

.button-footer-left {
  position: absolute;
  bottom: 14px;
  z-index: 100;
  animation: fadeIn ease 500ms forwards;
  animation-delay: 500ms;
  opacity: 0;
}
.con-vs-popup .vs-popup {
  max-width: 600px;
}
.vs-select--label {
  font-size: 0.85rem;
  color: rgba(0, 0, 0, 0.6) !important;
}

.color-select {
  display: flex;
  align-items: center;
  justify-content: flex-start;

  li {
    position: relative;
    width: 20px;
    height: 20px;
    margin: 10px;
    border-radius: 50%;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;

    $colors: (
      #cccccc,
      #cea8bc,
      #a9c3c8,
      #bcd611,
      #de9c9b,
      #fbe6a2,
      #aac1f0,
      #b2a7d2,
      #bc4b31,
      #111111
    );
    @for $i from 1 through length($colors) {
      &:nth-child(#{$i}) {
        background-color: nth($colors, $i);
        box-shadow: 0px 8px 12px -6px lighten(nth($colors, $i), 0.9);
      }
    }

    .selected {
      position: absolute;
      display: block;
      border-radius: 50%;
      border: 3px solid black;
      width: 32px;
      height: 32px;
    }
  }
}
</style>
